import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgCheck from '../../svg/check.svg'
import { IconProps } from '../icon-props'

const CheckIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgCheck
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-check', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default CheckIcon
